// Generated by scripts/update-seeq-icons.js from src/svg/seeq/pin-o.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcPinO = {
  prefix: 'fak',
  iconName: 'pin-o' as IconName,
  icon: [
    1024,
    1024,
    [],
    'f963',
    'M701.4 209.9l112.7 112.7-189.5 189.4c-46.1 46.1-71.7 107.5-76.8 174.1l-5.1 81.9-286.7-286.7 81.9-5.1c66.6-5.1 128-30.7 174.1-76.8l189.4-189.5zM665.6 5.1c-5.1-5.1-15.4-5.1-25.6 0l-112.6 112.7c-5.1 5.1-5.1 15.4 0 25.6l35.8 30.7-138.2 143.3c-25.6 25.6-61.4 41-97.3 41l-307.2 20.5c-15.4 0-20.5 15.4-10.3 25.6l256 256-266.2 271.3v92.2h92.2l266.2-266.2 256 256c10.2 10.2 25.6 5.1 25.6-10.3l20.5-307.2c0-35.8 15.4-71.7 40.9-97.3l148.5-138.2 35.9 35.8c5.1 5.1 15.4 5.1 25.6 0l112.6-112.6c0-5.1 0-15.4-5.1-25.6l-353.3-353.3z',
  ],
} satisfies IconDefinition;
